import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import notificationService from '../../../services/notificationService';
import { useEmployeeSelfService } from '../../../contexts/EmployeeSelfServiceContext';
import { formatDateFromApi } from '../../../utils/attendanceDateTime';

const routeForType = (type) => {
  const map = {
    leave: '/erp/employee-self-service/leave',
    payroll: '/erp/employee-self-service/payslip',
    attendance: '/erp/employee-self-service/attendance-details',
    regularization: '/erp/employee-self-service/regularization',
  };
  return map[type] || '/erp/employee-self-service';
};

const NotificationsSection = ({ onNotify }) => {
  const navigate = useNavigate();
  const { employee, notificationCenter, setNotificationCenter } = useEmployeeSelfService();

  const markRead = async (notification) => {
    if (notification.read_at) return;
    const result = await notificationService.markRead(notification.id);
    if (result.success) {
      setNotificationCenter((prev) =>
        prev.map((n) => (n.id === notification.id ? { ...n, read_at: new Date().toISOString() } : n))
      );
    }
  };

  const markAllRead = async () => {
    if (!employee?.id) return;
    const result = await notificationService.markAllAsRead(employee.id);
    if (result.success) {
      setNotificationCenter((prev) => prev.map((n) => ({ ...n, read_at: n.read_at || new Date().toISOString() })));
      onNotify?.({ message: 'All notifications marked read', type: 'success' });
    }
  };

  const handleOpen = async (notification) => {
    await markRead(notification);
    const route = notification.link || routeForType(notification.type);
    navigate(route);
  };

  return (
    <div className="space-y-6 pb-20 lg:pb-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold">Notifications</h2>
          <p className="text-sm text-muted-foreground">Updates on leave, payroll, and attendance</p>
        </div>
        <Button variant="outline" size="sm" onClick={markAllRead}>Mark all read</Button>
      </div>

      <div className="space-y-2">
        {notificationCenter.map((n) => (
          <button
            key={n.id}
            type="button"
            onClick={() => handleOpen(n)}
            className={`w-full text-left bg-card border rounded-lg p-4 flex gap-3 hover:bg-muted/30 transition ${!n.read_at ? 'border-primary/30' : ''}`}
          >
            <Icon name={n.read_at ? 'Bell' : 'BellRing'} size={18} className="shrink-0 mt-0.5 text-primary" />
            <div className="flex-1 min-w-0">
              <p className="font-medium text-sm">{n.title}</p>
              <p className="text-sm text-muted-foreground mt-0.5">{n.message}</p>
              <p className="text-xs text-muted-foreground mt-1">{formatDateFromApi(n.created_at)}</p>
            </div>
          </button>
        ))}
        {notificationCenter.length === 0 && (
          <p className="text-center py-12 text-muted-foreground">No notifications</p>
        )}
      </div>
    </div>
  );
};

export default NotificationsSection;
